export default __webpack_public_path__ + "static/24-body-modification-8143fd7f92516fd580c21b7370e35d11.png";